import { createReducer } from '@/redux/root';
import {
  nameSpace,
  pushToAspynAsync,
  pushHousingToAspynAsync,
  clearAspynResultAction,
  clearAspynHousingResultAction,
  requestMigrationJobsAsync,
} from './actions';
import { logoutAction } from '@/redux/auth';

const initialState = {
  aspynResult: null,
  aspynHousingResult: null,
  migrationJobs: {
    data: [],
    meta: null,
  },
};

export const aspynMigratorReducer = createReducer(nameSpace, initialState, {
  [pushToAspynAsync.success]: ({ state, action: { payload } }) => {
    state.aspynResult = payload;
  },

  [pushToAspynAsync.failure]: ({ state, action: { payload } }) => {
    // Store error response in a format compatible with the modal (as array)
    state.aspynResult = {
      data: {
        report: [{
          is_successful: false,
          message: payload?.response?.data?.errors?.[0]?.detail || 'An error occurred while pushing to Aspyn',
        }],
      },
    };
  },

  [clearAspynResultAction]: ({ state }) => {
    state.aspynResult = null;
  },

  [pushHousingToAspynAsync.success]: ({ state, action: { payload } }) => {
    state.aspynHousingResult = payload;
  },

  [pushHousingToAspynAsync.failure]: ({ state, action: { payload } }) => {
    // Store error response in a format compatible with the modal (as array)
    state.aspynHousingResult = {
      data: {
        report: [{
          is_successful: false,
          message: payload?.response?.data?.errors?.[0]?.detail || 'An error occurred while pushing to Aspyn',
        }],
      },
    };
  },

  [clearAspynHousingResultAction]: ({ state }) => {
    state.aspynHousingResult = null;
  },

  [requestMigrationJobsAsync.success]: ({ state, action: { payload } }) => {
    state.migrationJobs = {
      data: payload.data || [],
      meta: payload.meta || null,
    };
  },

  [requestMigrationJobsAsync.failure]: ({ state }) => {
    state.migrationJobs = {
      data: [],
      meta: null,
    };
  },

  [logoutAction]: ({ state }) => {
    state.aspynResult = null;
    state.aspynHousingResult = null;
    state.migrationJobs = {
      data: [],
      meta: null,
    };
  },
});
